import React from 'react';
import { Button } from './ui/button';
import { Twitter, MessageCircle, Send } from 'lucide-react';

/**
 * One-tap share buttons for Twitter, WhatsApp, Telegram.
 * Opens each platform's share URL in a new tab with a pre-filled invite.
 */
const ShareButtons = ({ referralUrl, referralCode }) => {
  const message = `I'm earning free Bitcoin on SatoshiShort by shortening links and claiming from the faucet. Use my code ${referralCode} and I'll get a 10% cut of everything you make — forever. Join here:`;

  const encodedMsg = encodeURIComponent(message);
  const encodedUrl = encodeURIComponent(referralUrl);

  const platforms = [
    {
      name: 'X',
      testId: 'share-twitter-btn',
      href: `https://twitter.com/intent/tweet?text=${encodedMsg}&url=${encodedUrl}`,
      Icon: Twitter,
      hoverBg: 'hover:bg-[#1DA1F2]/10',
      hoverText: 'hover:text-[#1DA1F2]',
      hoverBorder: 'hover:border-[#1DA1F2]/40',
      label: 'Twitter',
    },
    {
      name: 'WhatsApp',
      testId: 'share-whatsapp-btn',
      href: `https://wa.me/?text=${encodedMsg}%20${encodedUrl}`,
      Icon: MessageCircle,
      hoverBg: 'hover:bg-[#25D366]/10',
      hoverText: 'hover:text-[#25D366]',
      hoverBorder: 'hover:border-[#25D366]/40',
      label: 'WhatsApp',
    },
    {
      name: 'Telegram',
      testId: 'share-telegram-btn',
      href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedMsg}`,
      Icon: Send,
      hoverBg: 'hover:bg-[#26A5E4]/10',
      hoverText: 'hover:text-[#26A5E4]',
      hoverBorder: 'hover:border-[#26A5E4]/40',
      label: 'Telegram',
    },
  ];

  return (
    <div className="flex flex-col gap-3" data-testid="share-buttons">
      <p className="text-xs font-mono uppercase tracking-widest text-slate-500">
        Share Your Invite
      </p>
      <div className="grid grid-cols-3 gap-2">
        {platforms.map((p) => (
          <a
            key={p.name}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={p.testId}
            className="group"
          >
            <Button
              type="button"
              variant="outline"
              className={`w-full border-white/10 bg-[#0D0F17] text-slate-300 transition-all ${p.hoverBg} ${p.hoverText} ${p.hoverBorder}`}
            >
              <p.Icon className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">{p.label}</span>
              <span className="sm:hidden">{p.name}</span>
            </Button>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ShareButtons;
